import type { RouteId } from "./types";

const VALID_ROUTES = new Set<RouteId>([
  "home",
  "onboarding",
  "play",
  "setup",
  "club",
  "identity",
  "players",
  "player",
  "tactics",
  "activities",
  "profile",
  "more",
  "settings",
  "match",
  "results"
]);

export class Router {
  private listener: ((route: RouteId) => void) | null = null;

  constructor() {
    window.addEventListener("hashchange", () => this.emit());
  }

  start(listener: (route: RouteId) => void): void {
    this.listener = listener;
    this.emit();
  }

  current(): RouteId {
    const raw = window.location.hash.replace(/^#\/?/, "") as RouteId;
    return VALID_ROUTES.has(raw) ? raw : "home";
  }

  navigate(route: RouteId, replace = false): void {
    const next = `#/${route}`;
    if (replace) {
      window.history.replaceState(null, "", next);
      this.emit();
    } else if (window.location.hash !== next) {
      window.location.hash = next;
    } else {
      this.emit();
    }
  }

  private emit(): void {
    this.listener?.(this.current());
  }
}
